// removed by extract-text-webpack-plugin
module.exports = {"whyCardlessEmiOuterContainer":"whyCardlessEmiOuterContainer__2hMAb","whyCardlessEmiInnerContainer":"whyCardlessEmiInnerContainer__d3Qb6","cardContainer":"cardContainer__1WAV8","heading":"heading___kCBD","card":"card__2i99C","headingCard":"headingCard__2f3BC"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/whyCardlessEmi/style.css
// module id = 0adz
// module chunks = 444